import styled from 'styled-components'

import theme from 'theme_'
import CommonLink from 'components/Button/CommonLink'
import { BlurredBlock } from 'components/Layout'
import { Font16, Secondary } from 'components/Typography'

export const StyledLoginContainer = styled(BlurredBlock)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 600px;
  margin: 150px auto;
  background-color: ${theme.colors.white};

  @media ${theme.devices.tablet} {
    input {
      margin-bottom: 20px;
    }
  }

  @media ${theme.devices.mobile} {
    margin: 124px 24px;
    margin-bottom: 62px;
    width: inherit;
  }
`

export const StyledLoginInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: ${theme.spacing.xxxl} ${theme.spacing.md};
  border-radius: 0 0 ${theme.spacing.xs} ${theme.spacing.xs};
  background-color: rgba(0, 0, 0, 0.3);

  @media ${theme.devices.tablet} {
    padding: ${theme.spacing.lg};
  }
`

export const StyledNeedAccount = styled(Secondary)`
  text-align: center;
  color: ${theme.colors.mutedGray};

  @media ${theme.devices.tablet} {
    ${Font16};
    line-height: 22px;
    padding: 0 52px;
  }
`
export const StyledStoreIconsWrapper = styled.div`
  margin: ${theme.spacing.sm} 0;
  > a:first-child {
    margin-right: ${theme.spacing.base};
  }

  @media ${theme.devices.desktop} {
    margin: ${theme.spacing.xl} 0;
  }
`
export const StyledStoreIcon = styled.a`
  :hover {
    opacity: 0.8;
  }
`
export const StyledStoreIconImg = styled.img`
  height: 44px;

  @media ${theme.devices.tablet} {
    height: auto;
  }
`
export const StyledSystemInstalled = styled.div`
  margin-bottom: ${theme.spacing.xs};
`

export const StyledFindDealer = styled(CommonLink)`
  font-weight: 700;
  margin-left: ${theme.spacing.tiny};
`
